import { c as _c } from "react/compiler-runtime";
import React from 'react';
import Link from 'next/link';
import isProtectedRoute from '../../src/utils/isProtectedRoute';

// Extract the hash (if any) from a react-router `to` prop, which can be either a
// string ("/path#section") or a location-like object ({ pathname, hash }).
const hasHashTarget = to => {
  if (typeof to === 'string') return to.includes('#');
  if (to && typeof to === 'object') return Boolean(to.hash);
  return false;
};

// Pathname of a react-router `to` prop, without query string or hash.
const getPathname = to => {
  if (typeof to === 'string') return to.split(/[?#]/)[0];
  if (to && typeof to === 'object' && typeof to.pathname === 'string') {
    return to.pathname;
  }
  return '';
};
const LinkMock = React.forwardRef((props, ref) => {
  const $ = _c(11);
  let prefetch;
  let rest;
  let scroll;
  let to;
  if ($[0] !== props) {
    ({
      to,
      scroll,
      prefetch,
      ...rest
    } = props);
    $[0] = props;
    $[1] = prefetch;
    $[2] = rest;
    $[3] = scroll;
    $[4] = to;
  } else {
    prefetch = $[1];
    rest = $[2];
    scroll = $[3];
    to = $[4];
  }
  const resolvedPrefetch = isProtectedRoute(getPathname(to)) ? false : prefetch;
  const resolvedScroll = scroll ?? (hasHashTarget(to) ? undefined : false);
  let t0;
  if ($[5] !== ref || $[6] !== resolvedPrefetch || $[7] !== resolvedScroll || $[8] !== rest || $[9] !== to) {
    t0 = <Link {...rest} scroll={resolvedScroll} prefetch={resolvedPrefetch} href={to} ref={ref} />;
    $[5] = ref;
    $[6] = resolvedPrefetch;
    $[7] = resolvedScroll;
    $[8] = rest;
    $[9] = to;
    $[10] = t0;
  } else {
    t0 = $[10];
  }
  return t0;
});
export default LinkMock;